module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading_div"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d6e059a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/Loadingdiv.vue
// module id = 178
// module chunks = 1